export default __webpack_public_path__ + "static/media/frontCover.5f53499d.txt";